export default __webpack_public_path__ + "static/media/press_2.3e6ccdb3.webp";